// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__u8vsI","content":"styles_content__7Xw1c","tableWrap":"styles_tableWrap__35Zsp"};